var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1519 4.24434H2.59108C1.2203 4.24434 0.11377 5.35087 0.11377 6.72165V10.0247C0.11377 10.9331 0.856964 11.6763 1.76531 11.6763H3.41685V13.3278C3.41685 14.2362 4.16005 14.9794 5.0684 14.9794H11.6746C12.5829 14.9794 13.3261 14.2362 13.3261 13.3278V11.6763H14.9777C15.886 11.6763 16.6292 10.9331 16.6292 10.0247V6.72165C16.6292 5.35087 15.5227 4.24434 14.1519 4.24434ZM10.8488 13.3278H5.89417C5.43999 13.3278 5.0684 12.9562 5.0684 12.502V9.19896H11.6746V12.502C11.6746 12.9562 11.303 13.3278 10.8488 13.3278ZM14.1519 7.54742C13.6977 7.54742 13.3261 7.17582 13.3261 6.72165C13.3261 6.26748 13.6977 5.89588 14.1519 5.89588C14.6061 5.89588 14.9777 6.26748 14.9777 6.72165C14.9777 7.17582 14.6061 7.54742 14.1519 7.54742ZM12.5003 0.115479H4.24263C3.78845 0.115479 3.41685 0.487076 3.41685 0.94125V2.59279C3.41685 3.04697 3.78845 3.41856 4.24263 3.41856H12.5003C12.9545 3.41856 13.3261 3.04697 13.3261 2.59279V0.94125C13.3261 0.487076 12.9545 0.115479 12.5003 0.115479Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIcon);
export default __webpack_public_path__ + "static/media/print-icon.8e6f305d261eb25064643ce141ffa96f.svg";
export { ForwardRef as ReactComponent };